var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f106b302-7eb3-42b8-a3e6-0ca5025f95d0",
    "data-name": "fb53c1e0-8e03-45cb-883f-9dc02e2d8ce2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.9844 115.9844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.3489,0H4.6433A4.6344,4.6344,0,0,0,.0039,4.6394V111.345a4.6344,4.6344,0,0,0,4.6394,4.6394H111.3489a4.6344,4.6344,0,0,0,4.6394-4.6394V4.6394A4.6344,4.6344,0,0,0,111.3489,0ZM97.9527,33.8529H88.6885c-7.2636,0-8.67,3.4506-8.67,8.5249v11.178h17.34L95.0966,71.0549H80.0186v44.9295H61.94V71.0694H46.8181V53.5558H61.94V40.6525c0-14.9765,9.1482-23.1389,22.5154-23.1389a122.39,122.39,0,0,1,13.5122.6959V33.8529Z",
    transform: "translate(-0.0039)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ff942a2a.svg";
export { ForwardRef as ReactComponent };